import { AxiosPromise } from "axios";
import service from "../apis/Service";
import DtoSelectSearchParamInvoiceTaxRate from "../models.machine/DtoSelectSearchParamInvoiceTaxRate";
import RESTfulResult from "../models.machine/RESTfulResult";
import UiSelectOption from "../models.machine/UiSelectOption";
import DtoPageListSearchParamInvoiceTaxRate from "../models.machine/DtoPageListSearchParamInvoiceTaxRate";
import DtoPageListParamInvoiceTaxRate from "../models.machine/DtoPageListParamInvoiceTaxRate";
import UiDrag from "../models.machine/UiDrag";
import DtoDetailParamInvoiceTaxRate from "../models.machine/DtoDetailParamInvoiceTaxRate";
import DtoFormParamInvoiceTaxRate from "../models.machine/DtoFormParamInvoiceTaxRate";
import DtoListItemParamInvoiceTaxRate_Repeat from "../models.machine/DtoListItemParamInvoiceTaxRate_Repeat";

/**
 * 开票税率
 * @description 自动生成的代码,请勿修改
 */
export default class ParamInvoiceTaxRateAppService {
    /**
     * 获取开票税率选择器
     * @param {DtoSelectSearchParamInvoiceTaxRate} [search] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<UiSelectOption<string>[]>>} 选择器
     */
    static GetSelect(search?: DtoSelectSearchParamInvoiceTaxRate): AxiosPromise<RESTfulResult<UiSelectOption<string>[]>> {
        const url = `/api/ParamInvoiceTaxRate/GetSelect`;
        return service.get<RESTfulResult<UiSelectOption<string>[]>>(url, { params: search });
    }

    /**
     * 获取开票税率分页列表
     * @param {DtoPageListSearchParamInvoiceTaxRate} [dto] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<DtoPageListParamInvoiceTaxRate>>} 分页列表
     */
    static Get(dto?: DtoPageListSearchParamInvoiceTaxRate): AxiosPromise<RESTfulResult<DtoPageListParamInvoiceTaxRate>> {
        const url = `/api/ParamInvoiceTaxRate/Get`;
        return service.get<RESTfulResult<DtoPageListParamInvoiceTaxRate>>(url, { params: dto });
    }

    /**
     * 拖曳排序
     * @param {UiDrag<string>} [dto] 传参
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static DragSort(dto?: UiDrag<string>): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamInvoiceTaxRate/DragSort`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 获取开票税率详细
     * @param {string} [id] Id
     * @returns {AxiosPromise<RESTfulResult<DtoDetailParamInvoiceTaxRate>>} 详细
     */
    static GetById(id?: string): AxiosPromise<RESTfulResult<DtoDetailParamInvoiceTaxRate>> {
        const url = `/api/ParamInvoiceTaxRate/Get/${id}`;
        return service.get<RESTfulResult<DtoDetailParamInvoiceTaxRate>>(url);
    }

    /**
     * 新增/编辑开票税率
     * @param {DtoFormParamInvoiceTaxRate} [dto] 表单
     * @returns {AxiosPromise<RESTfulResult<any>>} Id
     */
    static Post(dto?: DtoFormParamInvoiceTaxRate): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamInvoiceTaxRate/Post`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 批量删除开票税率
     * @param {string[]} [ids] Id
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Delete(ids?: string[]): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamInvoiceTaxRate/Delete`;
        return service.delete<RESTfulResult<any>>(url, { data: ids });
    }

    /**
     * 导出
     * @param {string} [name] 
     * @param {string[]} [ids] 
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static PostExportExceByName(name?: string, ids?: string[]): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/ParamInvoiceTaxRate/PostExportExce/${name}`;
        return service.post<RESTfulResult<string>>(url, ids);
    }

    /**
     * 导出导入模板
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static GetExportImportTemplate(): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/ParamInvoiceTaxRate/GetExportImportTemplate`;
        return service.get<RESTfulResult<string>>(url);
    }

    /**
     * 导入
     * @param {any} [file] 
     * @returns {AxiosPromise<RESTfulResult<boolean>>} 
     */
    static PostImport(file?: any): AxiosPromise<RESTfulResult<boolean>> {
        const url = `/api/ParamInvoiceTaxRate/PostImport`;
        return service.post<RESTfulResult<boolean>>(url, file);
    }

    /**
     * 获取数据，用于重复判断
     * @returns {AxiosPromise<RESTfulResult<DtoListItemParamInvoiceTaxRate_Repeat[]>>} 
     */
    static GetList(): AxiosPromise<RESTfulResult<DtoListItemParamInvoiceTaxRate_Repeat[]>> {
        const url = `/api/ParamInvoiceTaxRate/GetList`;
        return service.get<RESTfulResult<DtoListItemParamInvoiceTaxRate_Repeat[]>>(url);
    }

}
